import React from "react";
import { connect } from "react-redux";

import moment from "moment";
import { getRequestType } from "../Support/redux/action";
import { checkCCTV } from "./redux/action";
import { Card } from "reactstrap";
import WebView from "./FootprintWebView";
import DefaultConstants from "../../defaultConstants";
class CCTV extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      childOnPause: false,
    };
  }

  componentDidMount() {
    if (
      this.props.user &&
      this.props.user.pause_state === 1
    ) {
      if (this.state.childOnPause === false) {
        this.setState({
          childOnPause: true,
        });
      }
    } else {
      this.props.checkCCTVConnection();
    }

  }

  componentDidUpdate(prevProps, prevState) {
    if (
      typeof prevProps.user === "undefined" &&
      this.props.user &&
      this.props.user.pause_state === 1
    ) {
      if (this.state.childOnPause === false) {
        this.setState({
          childOnPause: true,
        });
      }
    } else {
      this.props.checkCCTVConnection();
    }
    /* if (
      typeof prevProps.user === "undefined" &&
      this.props.user &&
      this.props.user.id
    ) {
      this.props.checkCCTVConnection();
    }*/
  }

  render() {
    //
    //const { cctvLinks } = this.props;
  
    if (this.state.childOnPause === true) {
      return (
        <div>
          {DefaultConstants.cameraPauseTitle}
          <br></br>
          {DefaultConstants.cameraPauseSubtitle}
        </div>
      );
    } else if (this.props.cctvDown === true) {
      return (
        <div>
          <h3>CCTV connections seems down.</h3>
          <h4>We sincerely regret the inconvenience caused.</h4>
          <h4>We will update you shortly.</h4>
          <button
            onClick={() => {
              this.props.checkCCTVConnection();
            }}
          >
            Refresh
          </button>
        </div>
      );
    } else if (this.props.user && this.props.user.html5_player_link) {
      console.log(
        "check value of this.props.user.html5_player_link : " +
          this.props.user.html5_player_link
      );

      return (
        <Card className="border-0 shadow  card-timeline mt-4 mb-4">
          <WebView url={this.props.user.html5_player_link} />
        </Card>
      );
    }
    // else if (
    //   !moment().isBetween(moment("08:45", "hh:mm"), moment("18:45", "hh:mm"))
    // ) {
    //   return <h4>{this.props.constants.cameraAvaiableTimings}</h4>;
    // }
    else {
      return <div />;
    }
  }
}
const mapStateToProps = (state) => {
  return {
    constants: state.constants,
    cctvLinks:
      state.userState.user &&
      state.userState.user.activeChildDetail &&
      state.userState.user.activeChildDetail.cctv_links,
    user: state.userState.user && state.userState.user.activeChildDetail,
    cctvDown: state.cctv.centerCctvDown,
    allowedServices: state.support.requestType.allowedServices,
  };
};

const mapDispatchToProps = (dispatch) => ({
  checkCCTVConnection: () => dispatch(checkCCTV()),
  getRequestType: () => dispatch(getRequestType()),
});
export default connect(mapStateToProps, mapDispatchToProps)(CCTV);
